import React from "react";

import { Hero } from "../hero";

const Home = () => {
  return (
    <React.Fragment>
      <Hero />
    </React.Fragment>
  );
};

export default Home;
